exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fields-restricted-manager[data-v-60e8d31c] {\n    margin-bottom: 20px;\n}\n", ""]);

// exports
